import { createColumnHelper } from '@tanstack/react-table'
import { formatDate } from '../../../../../../utils/tableFuncs'
import type { PurchaseReportAccountDetails } from '../../../../../../types'
import { formatCurrency } from '../../../utils/formatCurrency'
import { useSearchParams } from 'react-router-dom'

export default function purchaseReportAccountDetailsColumns() {
  const columnHelper = createColumnHelper<PurchaseReportAccountDetails>()
  return [
    columnHelper.accessor('transactionDate', {
      id: 'transactionDate',
      header: () => 'Dato',
      cell: (row) => formatDate(row.getValue()) || '',
    }),
    columnHelper.accessor('transactionTime', {
      id: 'transactionTime',
      header: () => 'Tidspunkt',
      cell: (row) => (row.getValue() ? `Kl. ${formatDate(row.getValue(), 'HH:mm')}` : ''),
    }),
    columnHelper.accessor('regNo', {
      id: 'regNo',
      header: () => 'Regnr',
      enableSorting: false,
      cell: () => useSearchParams()?.[0]?.get('regNo') || '',
    }),
    columnHelper.accessor('referenceNo', {
      id: 'referenceNo',
      enableSorting: false,
      header: () => 'Kortnr.',
      cell: (row) => (
        <span className="block text-ellipsis overflow-hidden whitespace-nowrap">{row.getValue() || ''}</span>
      ),
    }),
    columnHelper.accessor('retailStationName', {
      id: 'retailStationName',
      enableSorting: false,
      header: () => 'Stasjon',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('productDescription', {
      id: 'productDescription',
      enableSorting: false,
      header: () => 'Produkt',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('amountincVAT', {
      id: 'amountincVAT',
      meta: {
        mobileFooterLabel: 'Sum faktura inkl. mva',
        alignmentType: 'right',
      },
      header: () => 'Faktura inkl. mva',
      cell: (row) => formatCurrency(row.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amountincVAT') as number) || 0), 0)
        return formatCurrency(total)
      },
    }),
  ]
}
